// core
import React from "react";
import { Link } from "react-router-dom";

// settings + utils
import Settings from "config.js";
import Auth from "services/Auth.js";
import API from "utils/API.js";
import CSV from "utils/CSV.js";

// lib
import Page from "pages/shared/Page";
import Spinner from "components/shared/Spinner";
import PieChart from "react-minimal-pie-chart";

class SurveyResultsPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      working: false,
      fetching: false,

      survey: null,
      responses: []
    };
  }

  componentDidMount() {
    const { surveyId } = this.props.match.params;

    // get survey
    this.setState({
      fetching: true
    });

    // get survey
    API.call(
      "GET",
      Settings.V3_API_URL + "/surveys/" + surveyId,
      {},
      (response, error) => {
        if (error) {
          this.setState({
            fetching: false,

            error: error.message + " while getting survey"
          });

          return false;
        }

        const survey = response.data.survey;

        this.setState({
          fetching: false,

          survey
        });

        // get responses
        API.call(
          "GET",
          Settings.V3_API_URL + "/surveys/" + surveyId + "/responses",
          {},
          (response, error) => {
            if (error) {
              this.setState({
                fetching: false,

                error: error.message + " while getting responses"
              });

              return false;
            }

            const responses = response.data.responses;

            this.setState({
              fetching: false,

              responses
            });
          }
        );
      }
    );
  }

  render() {
    let HTMLContent = [<hr key="hr" />];
    const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    const colors = [
      "deepSkyBlue",
      "#4caf50",
      "tomato",
      "orange",
      "gold",
      "cyan",
      "grey",
      "lavender",
      "teal",
      "navy",
      "lightBlue",
      "brown",
      "paleGreen",
      "lightGreen",
      "aqua"
    ];

    // map questions with responses
    if (this.state.survey && this.state.responses) {
      const form = JSON.parse(this.state.survey.form);
      console.dir(form);

      let responsesByField = {};
      this.state.responses.forEach(response => {
        const formData = JSON.parse(response.form_data);

        const fieldnames = Object.keys(formData);
        for (let i = 0; i < fieldnames.length; i++) {
          const fieldname = Object.keys(formData)[i];
          const value = formData[fieldname];
          if (responsesByField[fieldname] == undefined) {
            responsesByField[fieldname] = {
              __MUH_TOTAL: 0
            };
          }
          if (responsesByField[fieldname][value] == undefined) {
            responsesByField[fieldname][value] = 0;
          }

          responsesByField[fieldname][value] = responsesByField[fieldname][value] + 1;
          responsesByField[fieldname]["__MUH_TOTAL"] = responsesByField[fieldname]["__MUH_TOTAL"] + 1;
        }
      });

      form.schema.fields.forEach((field, i) => {
        const pieChartData = [];
        HTMLContent.push(
          <div className="mt-5 mb-4" key={i}>
            <h4>
              <span style={{ color: "#777" }}>{i + 1}.</span> {field.label}
            </h4>
            <div className="row">
              <div className="col-4">
                {field.type === "select" &&
                  responsesByField[field.name] &&
                  field.options.map((option, j) => {
                    if (responsesByField[field.name][option.value] > 0) {
                      pieChartData.push({
                        color: colors[j],
                        title: alphabet[j],
                        value: responsesByField[field.name][option.value]
                      });
                    }
                  })}
                <PieChart
                  animate={false}
                  animationDuration={500}
                  animationEasing="ease-out"
                  cx={50}
                  cy={50}
                  data={pieChartData}
                  label={props => {
                    return props.data[props.dataIndex].title;
                  }}
                  labelPosition={112}
                  labelStyle={{
                    fontFamily: "sans-serif",
                    fontSize: "10px",
                    fill: "#121212",
                    fontWeight: "bold"
                  }}
                  lengthAngle={360}
                  lineWidth={100}
                  onClick={undefined}
                  onMouseOut={undefined}
                  onMouseOver={undefined}
                  paddingAngle={0}
                  radius={40}
                  ratio={1}
                  rounded={false}
                  startAngle={0}
                  style={{
                    height: "210px"
                  }}
                />
              </div>
              <div className="col-8">
                {field.type == "select" &&
                  responsesByField[field.name] &&
                  responsesByField[field.name] &&
                  field.options.map((option, j) => {
                    const percentage =
                      Math.round(
                        (responsesByField[field.name][option.value] /
                          responsesByField[field.name]["__MUH_TOTAL"]) *
                          100
                      ) + "%";
                    let key = `${i} + ${j}`;
                    return (
                      <div className="mt-3" key={key}>
                        <strong>{alphabet[j]}</strong> {option.label}
                        <br />
                        <div
                          style={{
                            display: "inline-block",
                            width:
                              (
                                responsesByField[field.name][option.value] /
                                (responsesByField[field.name]["__MUH_TOTAL"] /
                                  100)
                              ).toFixed(0) *
                                9 +
                              "px",
                            height: "19px",
                            borderRadius: "6px",
                            backgroundColor: colors[j]
                          }}
                        >
                          {responsesByField[field.name][option.value] && (
                            <span
                              style={{
                                color: "white",
                                paddingLeft: "10px",
                                fontSize: "15px",
                                bottom: '1px',
                                position: "relative"
                              }}
                            >
                              {percentage}
                            </span>
                          )}
                        </div>
                        <span className="ml-2">{responsesByField[field.name][option.value]}</span>
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>
        );
      });
    }

    return (
      <div className="container">
        <div className="row">
          <div className="col-12">
            {this.state.error ? (
              <div className="alert alert-danger">
                <h2>Oh, mamma!</h2>
                <p>{this.state.error}</p>
              </div>
            ) : (
              <div>
                {this.state.fetching ||
                this.state.working ||
                this.state.survey == undefined ? (
                  <Spinner message="Attendere..." />
                ) : (
                  <div>
                    <p>
                      <Link
                        to={
                          "/marketing/surveys/" +
                          this.state.survey.id +
                          "/view/-/"
                        }
                      >
                        <i className="fa fa-arrow-left" /> torna al sondaggio
                      </Link>
                    </p>

                    <h1>
                      Risultati "
                      {this.state.survey ? this.state.survey.title : ""}"
                    </h1>
                    {<div>{HTMLContent}</div>}
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default SurveyResultsPage;


// WEBPACK FOOTER //
// ./src/pages/marketing/surveys/SurveyResultsPage.js